import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup: function setup(__props) {
    // import { useOrientation } from './hooks/useOrientation'
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // eslint-disable-next-line no-undef
    // const version = APP_VERSION
    // useOrientation()
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});